export default {
  cookiePolicy: '/cookie-richtlinie',
  login: '/login',
  signup: '/signup',
  discord: 'https://discord.gg/example',
  // Add other links as needed
};
